import {
  LOGIN_EVENTS,
  LOGIN_FROM_TABS,
  LOGIN_MAGIC_LINK_REQUEST_SOURCES,
  LOGIN_OAUTH_PROVIDERS,
  LOGIN_PRIMARY_METHODS,
  LOGIN_SURFACES,
  useTrackLoginEvent as useTrackLoginEventCommon,
  type LoginPrimaryMethod,
} from '@liscio/common';

import { config } from '../../config';

export {
  LOGIN_EVENTS,
  LOGIN_FROM_TABS,
  LOGIN_MAGIC_LINK_REQUEST_SOURCES,
  LOGIN_OAUTH_PROVIDERS,
  LOGIN_PRIMARY_METHODS,
  LOGIN_SURFACES,
  type LoginPrimaryMethod,
};

/**
 * Firm app login analytics — merges `user_type: firm`, platform, and app version.
 */
export function useTrackLoginEvent(options?: {
  defaultLoginSurface?: (typeof LOGIN_SURFACES)[keyof typeof LOGIN_SURFACES];
}) {
  return useTrackLoginEventCommon({
    userType: 'firm',
    appVersion: config.version,
    platform: config.platform,
    defaultLoginSurface: options?.defaultLoginSurface ?? LOGIN_SURFACES.LOGIN_V5_NATIVE,
  });
}
